module.exports = "<div class=\"version\">\n    <p class=\"text-secondary\">{{text}}</p>\n</div>"